export const getLabelFromId = <T extends { id: string; label: string }>(id: string, list?: T[]) => {
  return list?.find(result => result.id === id)?.label ?? `id: ${id}`;
};
